import {gsap} from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import Scroller from "@templates/Scroller/Scroller.js";

gsap.registerPlugin(ScrollToPlugin);

const ReportTree = {

    init() {
        this.el = $('[component="ReportTree"]');
        if (!this.el.length) return;

        this.list = $('[component="ReportList"]');
        this.items = this.el.find('li.year');
        this.isSimple = this.el.hasClass('simple');
        const rootStyles = getComputedStyle(document.documentElement);
        this.fixedHeaderHeight = parseInt(rootStyles.getPropertyValue('--fixed-header-height').trim(), 10)
        this.bind();
    },

    bind() {
        this.items.click((evt) => {
            const item = $(evt.currentTarget);

            if (this.isSimple) {
                this.scrollTo(item);
            } else {
                this.toggle(item);
            }

        })
    },

    scrollTo(item) {
        const year = item.data('year');
        let section = this.list.find(`.year[data-year="${year}"]`);
        const y = section.offset().top - this.list.offset().top;
        let shift = 0;
        if (y < window.scrollY) {
            $('.isSticky').addClass('scrollUp');
            shift = this.fixedHeaderHeight;
        }
        if(item.index() === 0){
            section = this.list;
        }
        gsap.to(window, {scrollTo: {y: section, offsetY: shift}, duration: 0.7, ease: "power2.inOut"});
    },

    toggle(item) {
        if (!item.is('.open')) {
            this.open(item);
        } else {
            this.close(item);
        }
    },

    open(item) {
        this.close(item.siblings('.open'));
        const content = item.find('ul.issues');
        item.addClass('open');

        gsap.set(content, {display: 'block', height: 0, overflow: 'hidden'});
        gsap.to(content, {height: 'auto', duration: 0.4, ease: "power2.out"});
    },

    close(item) {
        if (!item.length) return;
        const content = item.find('ul.issues');
        item.removeClass('open');

        gsap.to(content, {
            height: 0, duration: 0.4, ease: "power2.inOut", overflow: 'hidden', onComplete: () => {
                gsap.set(content, {clearProps: 'display'});
            }
        });
    }

}

export default ReportTree;